import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import '../styles/urbantxt-packages.css';
import '../styles/main.scss';
import { Helmet } from 'react-helmet-async';
import { CustomProvider } from 'rsuite';
import useWindowResizeObserver from 'hooks/useWindowResizeObserver';
import TableProviderRosie from 'providers/TableProviderRosie';

type AppProviderProps = {
  children: React.ReactNode;
};

const description = ``;

export default function AppProvider({ children }: AppProviderProps) {
  useWindowResizeObserver();
  return (
    <>
      <Helmet>
        <title>TXT Teens Exploring Technology </title>
        <meta name="description" content={description} />
      </Helmet>
      <CustomProvider theme="light">
        <TableProviderRosie>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            {children}
          </Router>
        </TableProviderRosie>
      </CustomProvider>
    </>
  );
}
